import flagImg from "../assets/korean-flag.png";
import logoImg from "../assets/papualng-logo.png";

/**
 * Korean flag + Papua LNG Project logo, side by side — the site's core brand mark.
 * `size` sets the logo's width/height; the flag is scaled to the same height
 * (Korean flag is a 3:2 ratio, so its width is derived from that height).
 */
export default function BrandMarks({ size = 38 }) {
  const flagWidth = Math.round(size * 1.5);
  return (
    <div className="brand-marks">
      <img src={flagImg} alt="Republic of Korea flag" className="brand-flag"
        style={{ width: flagWidth, height: size }} />
      <img src={logoImg} alt="Papua LNG Project logo" className="brand-logo"
        style={{ width: size, height: size }} />
    </div>
  );
}
